import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { UserInfoService } from './userInfo.service';


@Injectable({ providedIn: 'root' })
export class VendorService {

  private _refreshNeeded$ = new Subject<void>();
  notifyCount$ = new Subject<number>();
  infoUpdateCount$ = new Subject<number>();

  constructor(private http: HttpClient,
    private commonService: CommonService,
    readonly userInfoService: UserInfoService
  ) { }

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  // service to create vendor 
  createvendor(data, headers?): Observable<any> {
    return this.commonService.postCall(environment.API_BASE_PATH + '/users/create', data, headers);
  }

  // Service to get all Stations
  // getvendorlist() {
  //   return this.commonService.getCall(environment.API_BASE_PATH + '/vendor/findall');
  // }

  getporttypelist() {
    return this.commonService.getCall(environment.API_BASE_PATH + '/chargebox/metadata/station');
  }

  getAllVendors(index, rows, column, direction, search) {
    let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/vendor', headers);
  }

  // Service to get station details using vendor id
  getvendorinfobyvendorid(id, groupType?) {
    let headers = { headers: { 'group_type': !!groupType ? groupType : '' ,'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
    return this.commonService.getCall(environment.API_BASE_PATH + `/vendor/${id}`, headers);
  }

  // Service to delete station details using sationid
  deletevendorbyid(id) {
    return this.commonService.deleteCall(environment.API_BASE_PATH + `/vendor/delete/${id}`)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      )
  }

  // Service to update station details
  updatevendor(data, headers?): Observable<any> {
    return this.commonService.putCall(environment.API_BASE_PATH + '/vendor', data, headers);
  }

  // to get Notifications by vendor id
  getAlertAndNotificationbyvendorid(vendorId, index, rows, column, direction, search) {
    if (index == null && rows == null) {
      return this.commonService.getCall(environment.API_BASE_PATH + `/notification/findByVendorId/${vendorId}`);
    }
    else {
      let headers = { headers: { vendorId: String(vendorId), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction) } };
      return this.commonService.getCall(environment.API_BASE_PATH + '/notification/findByVendorId', headers);
    }
  }

  // to get all notifications
  getAlertAndNotification(index, rows, column, direction, search) {
    if (index == null && rows == null) {
      return this.commonService.getCall(environment.API_BASE_PATH + `/notification/vendor/list`);
    }
    else {
      let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
      return this.commonService.getCall(environment.API_BASE_PATH + `/notification/vendor/list`, headers);
    }
  }
  // to get count of notification
  getNotificationcount(id: string) {
    if (!id)
      return;
    return this.commonService.getCall(environment.API_BASE_PATH + `/notification/count?viewStatus=unseen&vendorId=${id}`);
  }

  getNotificationcountseen(id: string) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/notification/count?viewStatus=seen&vendorId=${id}`);
  }

  getNotificationcountunseen(id: string) {
    return this.commonService.getCall(environment.API_BASE_PATH + `/notification/count?viewStatus=unseen&vendorId=${id}`);
  }

  // to delete the notification
  deletenotificationvendorbyid(id, conId) {
    return this.commonService.deleteCall(environment.API_BASE_PATH + `/notification/delete?chargeboxId=${id}&connectorId=${conId}`);
  }

  updatenotification(id) {
    return this.commonService.putCall(environment.API_BASE_PATH + `/notification/update?viewStatus=seen&vendorId=${id}`, {});
  }

  getInfoNotificationCount(id: string) {
    if (!id)
      return;
    return this.commonService.getCall(environment.API_BASE_PATH + `/status/count?userId=${id}`)
  }

  updateInfonotification(id, type) {
    return this.commonService.postCall(environment.API_BASE_PATH + `/status/save?userId=${id}&type=${type}`, {});
  }

  createAccount(data): Observable<any> {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.postCall(environment.API_BASE_PATH + '/users/accountDetails', data, headers);
  }

  updateAccount(data): Observable<any> {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.patchCall(environment.API_BASE_PATH + '/users/accountDetails', data, headers);
  }

  getAccount(vendorId) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/users/accountDetails/${vendorId}`, headers)
  }

  uploadProfilePic(vendorId, data): Observable<any> {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.postCall(environment.API_BASE_PATH + `/users/vendors/${vendorId}/images/profilePic`, data, headers);
  }

  uploadCompanyLogo(vendorId, data): Observable<any> {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.postCall(environment.API_BASE_PATH + `/users/vendors/${vendorId}/images/companyLogo`, data, headers);
  }

  changeStatusCpo(input) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.patchCall(environment.API_BASE_PATH + `/vendor/status`, input, headers)
  }

  getGstDetails(index, rows, column, direction, search,userId): Observable<any> {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID, 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search)  } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/gst/${userId}` , headers)
  }

  deactivateGst(gst_number, status, userID) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID, 'Gst-Number': gst_number, 'Status': status } };
    return this.commonService.putCall(environment.API_BASE_PATH + `/gst/updateStatus/${userID}`, {}, headers)
  }

  activateGst(gst_number, status, userID) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID, 'Gst-Number': gst_number, 'Status': status } };
    return this.commonService.putCall(environment.API_BASE_PATH + `/gst/updateStatus/${userID}`, {}, headers)
  }

  getGst(gst_number, userid) {
    let headers = { headers: { 'Accept-Version': 'V2' } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/gst/${gst_number}/${userid}`, headers)
  }

  getDynamicColumn(reportId):Observable<any> {
    let headers = { headers: { 'userId': this.userInfoService.userDetails.userId } };
    let apiUrl = environment.API_BASE_PATH + `/reports/${reportId}/dynamic-columns`;
    return this.commonService.getCall(apiUrl,headers);
    // return this.http.get('assets/dummyChargerReportColumn.json')
  }

  getAllWallets(index, rows, column, direction, search) {
    let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID  } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/wallets/getAll', headers);
  }

  updateDynamicColumns(data, reportId) {
    let headers = { headers: { 'userId': this.userInfoService.userDetails.userId } };
    let apiUrl = environment.API_BASE_PATH + `/reports/${reportId}/dynamic-columns`;
    return this.commonService.postCall(apiUrl, data, headers)
  }
  getOperatorList(email) {
    let headers = { headers: { 'Accept-Version': 'V2', 'email': email, 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
    return this.commonService.getCall(environment.API_BASE_PATH + '/users/operators', headers)
  }
}